function hljsDefineText() {
  return {}
}

export default hljsDefineText
